import { FlexColumn } from '../../atoms/layout/Flex'
import FieldView from '../../molecules/display/FieldView'
import CompanyWorkAreasView from './CompanyWorkAreasView'
import { ClientDetail } from '../../../types/Company'
import CompanyConstructionDetailsView from './CompanyConstructionDetailsView'

type Props = {
  clientDetail: ClientDetail
}

export default function ClientWorkView({ clientDetail }: Props) {
  return (
    <FlexColumn>
      <FieldView label="対応可能地域">
        <CompanyWorkAreasView areaIds={clientDetail.workAreaIds} highlightAreaIds={[]} />
      </FieldView>
      <CompanyConstructionDetailsView constructions={clientDetail.constructions} />
    </FlexColumn>
  )
}
